import moment from 'moment'
import { getCurrentLanguage } from 'utils'
import { ALI_TOKEN_KEY } from '../initAliFingerprint'

export function urlencoded(body) {
  const result = []
  // eslint-disable-next-line no-unused-vars
  for (const item in body) {
    // 去除数据中的undefined 和 空格
    if (body[item] && body[item] !== 'undefined') {
      const value = body[item].toString().replace(/ /g, '')
      result.push(`${item}=${encodeURIComponent(value)}`)
    }
  }
  return result.join('&')
}

export default function header({ method, endpoint, header, body, type }) {
  // if (process.env.NODE_ENV === 'development') {
  //   type = 'dev'
  //   method = 'GET'
  // }
  if (body && body.orderToken) {
    // 如果参数中包含orderToken, 尝试获取loginToken
    // Exception: query-install-plan endpoint for saved cards sends loginToken directly in body (handled in modules.js)
    // For new cards, loginToken is not needed for query-install-plan
    if (!endpoint || !endpoint.includes('query-install-plan')) {
      body.loginToken = sessionStorage[body.orderToken]
    }
    // For query-install-plan with payMethodShortNo, loginToken is already in body from modules.js
  }
  if (method === 'GET' && body) {
    endpoint += `?${urlencoded(body)}`
  }

  // Create base headers object
  const baseHeaders = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Content-Language': getCurrentLanguage(),
    platform: '4',
    'Utc-Offset-Seconds': moment().utcOffset() * 60,
  }

  // Ali fingerprint token is the only active fingerprint signal.
  const aliToken = sessionStorage.getItem(ALI_TOKEN_KEY)

  baseHeaders[ALI_TOKEN_KEY] = aliToken || ''

  // Merge with custom headers
  const jsonHeaders = { ...baseHeaders, ...header }

  const reqHeaders = {
    JSON: {
      headers: jsonHeaders,
      credentials: 'include',
      body: method === 'POST' ? JSON.stringify(body) : undefined,
    },
    'x-www-form-urlencoded': {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      credentials: 'include',
      body: method === 'POST' && urlencoded(body),
    },
    dev: {
      credentials: 'omit',
    },
  }
  return Object.assign({}, reqHeaders[type], {
    method: method,
    endpoint: `/cgs/api/${endpoint}`,
  })
}
